<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	

    <div class="mb-2">
      <el-form inline ref="form" :model="searchform">
            <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value1" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:100px" >
               <el-option
                      v-for="item in searchform.searchOptions1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:100px" >
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')"  v-model="searchform.keyword" size="mini" style="width:100px" ></el-input>
          </el-form-item>
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>  
          </el-form-item>
      </el-form>
       

        
    </div>
      <div class="d-flex align-items-center">
      <el-input :placeholder="$t('searchText.구글OTP')" v-model="otp" size="mini" style="width: 100px;" class="mr-2"></el-input>
    <el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
    <el-button type="success" size="mini" @click="add()">{{$t('searchText.쪽지보내기')}}</el-button>
  
  
  </div>
  <el-tabs v-model="activeName" @tab-click="handleClick" type="card" class="mt-2">
    <el-tab-pane :label="$t('searchText.보낸쪽지함')" name="first">
        <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
     <el-table-column width="80" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*50-scope.$index}}</template>
        </el-table-column>
          <el-table-column
        :label="$t('nav.아이디')" prop="attn" align="center" width="200">
          <template slot-scope="scope">
            
             <span @click="openModel(scope.row.attn)" class="text-primary" style="cursor:pointer">{{scope.row.attn}}</span>
          </template>
      </el-table-column>

      <el-table-column
        :label="$t('tableText.이름')" prop="mem_name" align="center" width="150">
          <template slot-scope="scope">
            
             {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})
          </template>
      </el-table-column> 
     
   
     
      
      
        <el-table-column
        
       :label="$t('tableText.보낸내용')" prop="wr_1">
         <template slot-scope="scope">
              <el-input
            type="textarea"
            :rows="2"
            v-model="scope.row.wr_1" v-on:click.native="editWr(scope)">
          </el-input>
          </template>
      </el-table-column> 

       

       <el-table-column
        :label="$t('tableText.보낸시간')"
         prop="add_date" align="center" width="300">
        
      </el-table-column> 

      <el-table-column
        :label="$t('tableText.읽은시간')"
        prop="read_date" align="center" >
        
      </el-table-column> 

      <el-table-column
        :label="$t('msg.답변내용')"
        prop="re_txt">
         <template slot-scope="scope">
              <el-input
            type="textarea"
            :rows="2"
            v-model="scope.row.re_txt" v-on:click.native="editWr(scope)">
          </el-input>
          </template>
      </el-table-column> 

      <el-table-column
         :label="$t('msg.답변시간')"
         prop="re_date" align="center" >
        
      </el-table-column> 

       
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
      
    </el-tab-pane>
    <el-tab-pane :label="$t('msg.받은쪽지함')" v-if="1==2" name="second">
       <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
        :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
     <el-table-column width="80" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*50-scope.$index}}</template>
        </el-table-column>
          <el-table-column
       :label="$t('nav.아이디')" prop="attn" align="center" width="200">
          <template slot-scope="scope">
            
             <span @click="openModel(scope.row.attn)" class="text-primary" style="cursor:pointer">{{scope.row.attn}}</span>
          </template>
      </el-table-column>

      <el-table-column
      :label="$t('tableText.이름')" prop="mem_name" align="center" width="150">
          <template slot-scope="scope">
            
             {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})
          </template>
      </el-table-column> 
     
   
     
      
      
        <el-table-column
        
       :label="$t('msg.내용')" prop="wr_1">
         <template slot-scope="scope">
              <el-input
            type="textarea"
            :rows="2"
            v-model="scope.row.wr_1" v-on:click.native="editWr(scope)">
          </el-input>
          </template>
      </el-table-column> 
       <el-table-column
         :label="$t('tableText.보낸시간')"
         prop="add_date" align="center" width="300">
        
      </el-table-column> 
       <el-table-column
        :label="$t('tableText.읽은시간')"
         prop="read_date" align="center" width="300">
        
      </el-table-column> 
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
    </el-tab-pane>

  </el-tabs>

        <el-dialog
          :width="dwidth"
           :title="$t('searchText.쪽지보내기')"
         :close-on-click-modal ="false"
          :visible.sync="creatModel" class="qaDialogB">
          <div class="d-flex" v-loading="qaLoading">
          <div style="width:70%">
          <el-form ref="form" :model="form" label-width="100px" v-loading="loading" :rules="rules">

            <el-form-item v-if="this.aid=='admin'" :label="$t('status.알본선택')">
              <el-select v-model="admin_id"  style="width: 100px;" class="ml-2 mr-2" size="mini">
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select> 
            </el-form-item>
             <div style="padding-left:100px" class="text-danger mb-1">
              1. {{$t('msg.아이디만입력시해당아이디로만전송')}}<br>2. {{$t('msg.아이디입력및부본총판매장선택시해당소속회원까지전송')}}<br>3. {{$t('msg.아이디없이레벨만선택시해당등급에만전송')}}
            </div>
            <el-form-item :label="$t('nav.아이디')" prop="mem_id">
              <el-input v-model="form.mem_id"></el-input>
            </el-form-item>
            <el-form-item :label="$t('msg.레벨')">
              <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="margin-right: 10px;">ALL</el-checkbox>-->
                  <div style="margin: 15px 0;"></div>
                  <el-checkbox-group v-model="level" @change="handlelevelChange">
                    <el-checkbox v-for="checkboxs in level_opt" :label="checkboxs.label" :key="checkboxs.value" style="margin-right: 10px;">{{checkboxs.label}}</el-checkbox>
                  </el-checkbox-group>
            </el-form-item>
           <el-form-item :label="$t('msg.내용')" prop="content">
               <el-input
            type="textarea"
            :rows="6"
            v-model="form.wr_1">
          </el-input>
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false" style="float:right;">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="memoSend()" style="float:right;" class="mr-2">{{$t('msg.확인')}}</el-button>
          </span>
        </div>
        <div class="border ml-auto p-2 d-flex" style="width:25%;flex-direction:column;align-items:start;height:450px;overflow-y:auto;">
            <el-button type="text" v-for="(item,index) in qa" :key="index"  class="py-2 ml-0" @click="qaChange(index)">{{item.title2}}</el-button>
          
          </div>
      </div>
        
       
       
        </el-dialog>
        <el-dialog
            :title="$t('status.편집')"
           :width="dwidth"
          :visible.sync="creatModel1" class="qaDialogB"
          :close-on-click-modal ="false">
          <div class="d-flex" v-loading="qaLoading">
          <div style="width:70%">
          <el-form ref="form" :model="form" label-width="100px">
          
          <el-form-item :label="$t('msg.내용')" prop="content">
            <el-input
            type="textarea"
            :rows="15"
            v-model="form.wr_1">
          </el-input>
            
            </el-form-item>
         
        
          
          
          </el-form>
          <span slot="footer" class="dialog-footer">
           
            <el-button @click="submit" style="float:right;">{{$t('msg.수정')}}</el-button>

            
          </span>
          </div>
           <div class="border ml-auto p-2 d-flex" style="width:25%;flex-direction:column;align-items:start;height:450px;overflow-y:auto;">
            <el-button type="text" v-for="(item,index) in qa" :key="index"  class="py-2 ml-0" @click="qaChange(index)">{{item.title2}}</el-button>
          
          </div>
        </div>
        </el-dialog>
        
</div>
 </template>

 <script>
  import { quillEditor, Quill  } from "vue-quill-editor";
Quill.register('modules/ImageExtend', ImageExtend)
import {ImageExtend, QuillWatch } from "quill-image-extend-module"
import "quill/dist/quill.core.css"; 
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
  import layer from '../../components/common/layer.vue';
    import layerNew from '../../components/common/layer-new.vue';

 const checkboxsOptions = ['0', '1', '2', '3', '4', '5', '6', '7'];

    export default {
    components: {
      layer,layerNew,quillEditor
    },
    	data(){
    		return{
           editorOption: {
           
            modules:{
            
              toolbar: {
                container:[
                     ['bold', 'italic', 'underline', 'strike'],  
                   
                     [{'list': 'ordered'}, {'list': 'bullet'}], 
                     ["image",'video','link'],
                     [{'color': []}, {'background': []}],
                    
                     [{'header': [1, 2, 3, 4, 5, 6, false]}],
                     
                ],
                 handlers: {
                    image(value) {
                      if (value) {
                        
                        document.querySelector('#upload').click()
                      } else {
                        this.quill.format('image', false)
                      }
                    },
                  },

              },
            },
             
            },
          dwidth:'900px',
           admin_id:'',
          adminlist:[{
             label:this.$i18n.t("status.선택"),
               
                value:''
            },
            
            ],
           level_opt:[
            {
               label:this.$i18n.t("msg.기본"),
            
              value:'0'
            },
             {
              label:'V1',
              value:'1'
            },
             {
              label:'V2',
              value:'2'
            }
            ,
             {
              label:'V3',
              value:'3'
            },
             {
              label:'V4',
              value:'4'
            },
             {
              label:'V5',
              value:'5'
            },
             {
              label:'V6',
              value:'6'
            },
             {
              label:'V7',
              value:'7'
            }

            ],
          activeName: 'first',
          tapidx:"0",
          qa:[],
          otp:'',
          qaLoading:false,
          creatModel1:false,
            level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")             
            },
          formLoading:false,
          idDialogVisible: false,
          domain:window.sessionStorage.getItem('domain'),
             sitetype:window.sessionStorage.getItem('sitetype'),
               bg:window.sessionStorage.getItem('bg'),
                 userid:window.sessionStorage.getItem('userid'),
                   aid:window.sessionStorage.getItem('admin_id'),
          form:{
            mem_id:'',
            idx:'',
            content:'',
            wr_1:'',
          },
    		 checkAll: false,
         level: [],
         cities: checkboxsOptions,
        isIndeterminate: true,
    			
    			searchform:{
    				keyword:'',
    				time:[],
              searchOptions1:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
             {
              label:this.$i18n.t("msg.회원"),
              value:'user'
            },
             {
              label:this.$i18n.t("msg.파트너"),
              value:'pt'
            }


            ],
            value1:'user',
    				searchOptions:[
                
    				{
		        label:this.$i18n.t("msg.아이디"),
		        	value:'attn'
		        },
		        ],

           
            value1:'user',
            searchOptions:[
                
            {
             label:this.$i18n.t("msg.아이디"),
              value:'attn'
            },
            ],
		       
            
		        value:'',

      


    			},
    			 pickerOptions: {
    			},
           shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
  
        
    
   
    			
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
               rules: {
                  
                  wr_1:[{ required: true, message: '', trigger: 'blur'}],
                },
              
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/bubonlist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
           let newids=[];

            let obj={};
            obj.label=this.$i18n.t("msg.없음")
            obj.value=''
            newids.push(obj); 

            newids=[];

            


            response.data.admin.forEach(item=>{
            let obj={};
            obj.label=item.name
            obj.value=item.name
            newids.push(obj);            
           });


           

           this.adminlist=newids
    
            }).catch((error) =>{
              
            })

    			this.getList();
    			
			
		},
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
    }
  },
  
    	methods:{
       change(e) {
          let token=window.sessionStorage.getItem('user');
          let file = e.target.files[0]
          const formData = new FormData()
          formData.append('file', file)
          this.$axios({
　　　　　　　　　　url: this.domain+'/admin/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formData,
　　　　　　　　　
　　　　　　　　}).then((url) => {
                    console.log('url:',url.data.data)
                     const quill = this.$refs.myQuillEditor.quill
                      quill.focus()
                      quill.insertEmbed(quill.getSelection().index, 'image', url.data.data)
                            　　　　　　　　　　
　　　　　　　　　
　　　　　　　　}).catch(err => {
          console.error(err)
        })

    
    },

          onEditorReady(editor) { // 准备编辑器
        },
          onEditorBlur(){}, // 失去焦点事件
          onEditorFocus(){}, // 获得焦点事件
          onEditorChange(event){
              //console.log(event.html)
               this.form.wr_1 = event.html
          }, 
         handleClick(tab, event) {
              //console.log(tab.index);
              this.tapidx=tab.index
              this.getList()
      },
        editWr(e){

                 
                    let token=window.sessionStorage.getItem('user');
          this.qaLoading = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/memo?idx='+e.row.idx,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             //  console.log('data====',response.data.auto_qa)
                  let item = response.data.data 
                  this.form ={
                    idx: item.idx,
                   
                    wr_1 : item.wr_1,
                  
                  }
                  this.qa = response.data.auto_qa
                  this.qaLoading = false    
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
             
          this.creatModel1 = true

        },
        qaChange(index){
          //console.log(index)
         
         
          this.form.wr_1 = this.qa[index].contents

        },
         // 关闭弹框（头部的X）
        
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         openModel(id){
           let pix=window.screen.width;
           
                let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }
          if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: [width+'', '700px'],
             
             });
              return;
           }
           
            this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
        submit(){
          this.loading = true
          let token=window.sessionStorage.getItem('user');
          
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/memo_up',
                      data:{  
                            idx:this.form.idx,
                            wr_1:this.form.wr_1,
                            
                      },
                            
                'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    if(response.data.code!=200){
                      this.$message.error(response.data.msg)
                    }
                    this.$message({
                      message:response.data.msg,
                  type:'success'
                    })
                    this.loading = false
                    this.getList()


                          //关闭
              this.creatModel1 = false
                
                          
                           
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                    
          
        },
        memoSend(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
           
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/memo_send',
                        data:{
                          content:this.form.wr_1,
                          mem_id:this.form.mem_id,
                          level:this.level,
                          admin_id:this.admin_id,
                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                                message:this.$i18n.t("msg.완료"),
                                type:'success'
                               });
                              
                             this.getList()
                            this.creatModel = false

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
        
            })
              
            
        },
        add(){
          let token=window.sessionStorage.getItem('user');
          this.qaLoading = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/autoqalist?type=memo',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             //console.log('data====',response.data.data)
                  let item = response.data.data 
                  this.form.wr_1=''
                  this.qa = item
                  this.qaLoading = false    
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
             
          this.creatModel = true
        },
         handleCheckAllChange(val) {
            this.level = val ? checkboxsOptions : [];
            this.isIndeterminate = false;
          },
          handlelevelChange(value) {

            console.log(value)
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
          },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              
            
this.currentPage=1;

    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
       // 批量删除
      deleteAll(){
      this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
         confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.id);
            newids.push(item.idx);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/memo_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
    		getList(){

    		
          let s_time="";
          let e_time="";

          if(this.searchform.time.length>0)
          {
              s_time=this.searchform.time[0];
              e_time=this.searchform.time[1];
          }
              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/memolist?user='+this.searchform.value1+'&type='+this.tapidx+'&post='+this.searchform.value1+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     //console.log('data=',response.data.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            
               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    	
    		
    	}
  }
</script>

 <style scoped>

.bg-danger{
  background-color:#72e8ff!important
 }
.bg-primary{
  background-color:#9dcdff!important
}
.bg-yellow {
    background-color: #f3ff77!important;
}
/deep/ .el-select-dropdown__item.selected{
  color:#000
}
/deep/ .el-input__inner{
  background:transparent;
  border:1px solid #cfcfcf;
  border-radius:2px;
}
/deep/ .el-dialog__body{
  padding:10px 20px;
}
/deep/ .el-form-item {
  margin-bottom:10px;
}

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
  .quill-editor{
   width: 100%;
 }
 >>>.ql-editor{
  height: 180px;
 
}
</style>


// WEBPACK FOOTER //
// src/views/memo_user/list.vue